import DrawBase from "./DrawBase"
import EditPolyline from "./EditPolyline"
class DrawPolyline extends DrawBase {
    constructor(options) {
        super(options);
        this.options = options;
        this.style=undefined;
    }

    //左键
    leftClick(evt) {
        var $this = this;
        var position = this.getCatesian3FromPX(evt.position);
        if (!position) {
            return;
        }
        if ($this.positions.length == 0) {
            $this.positions.push(position.clone());
        }
        $this.positions.push(position);
    }
    mouseMove(evt) {
        var $this = this;
        if ($this.positions.length < 1) return;
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        if (!$this.Cesium.defined($this.plot)) {
            $this.plot = $this.createPolyline($this.positions,this.style);
            this.entities.push($this.plot);
            this.initEditor();
        }
        if ($this.plot) {
            $this.positions.pop();
            $this.positions.push(cartesian);
        }
    }

    initEditor() {
        //初始化编辑器
        var $this = this;
        $this.editHelp = new EditPolyline(this.options); //初始化编辑类
    }
}

export default DrawPolyline;